import React from 'react';
import divider from '../../assets/divider-img.png';
import dividerWhite from '../../assets/divider-white.png';
import icon1 from '../../assets/sa1.png';
import icon2 from '../../assets/sa2.png';
import icon3 from '../../assets/sa3.png';
import amazon from '../../assets/amazon.png';
import forex from '../../assets/forex.png';
import crypto from '../../assets/crypto.png';

const ServicesExplore = () => {
  return (
    <div className="home-services">
      <div className="container">
        <div className="section-top service-explore-top">
          <h2>Explore the Power of Algorithmic Trading in Financial Markets</h2>
          <div className="divider">
            <img src={divider} alt="divider" />
          </div>
          <p>
            Welcome to our Algorithmic Trading service, where cutting-edge
            technology meets the financial markets. Our automated trading
            strategies leverage powerful algorithms to execute trades with speed
            and precision
          </p>
        </div>
        <div className="services-wrapper">
          <div className="service-item">
            <div className="service-icon">
              <img src={icon1} alt="services icon" />
            </div>
            <h3>Automation</h3>
            <p>
              Say goodbye to manual trading. Our algorithms automatically
              execute trades on your behalf
            </p>
          </div>
          <div className="service-item m-lr">
            <div className="service-icon">
              <img src={icon2} alt="services icon" />
            </div>

            <h3>Efficiency</h3>
            <p>
              Take advantage of split-second decision-making and seize trading
              opportunities instantly
            </p>
          </div>
          <div className="service-item">
            <div className="service-icon">
              <img src={icon3} alt="services icon" />
            </div>

            <h3>Reduced Emotional Bias</h3>
            <p>
              Eliminate emotions from trading decisions and stick to a
              well-defined strategy
            </p>
          </div>
        </div>

        <div className="services-explore-bottom">
          <div className="services-explore-bottom-left">
            <h2>Our Key Markets</h2>
            <div className="divider">
              <img src={dividerWhite} alt="divider" />
            </div>
            {/* <p>
              At Quantome, we pride ourselves on our expertise across a diverse
              range of markets. Leveraging the power of algorithmic trading, we
              have established a strong presence in the following key sectors:
              <br />
              Stocks: Dive into the dynamic world of equities with us. Our
              algorithms are designed to navigate the complexities of stock
              markets worldwide, identifying opportunities and executing trades
              with unparalleled precision.
              <br />
              Foreign Exchange (Forex): The 24/7 nature of the forex market
              demands a robust and responsive trading strategy. Our algorithms
              are tailored to capture subtle shifts in currency pair dynamics,
              ensuring optimal trade execution.
              <br />
              Cryptocurrencies: As digital currencies reshape the financial
              landscape, our cutting-edge algorithms stay ahead of the curve,
              capitalizing on the volatility and liquidity of the crypto market.
              <br />
              Real Estate Contracts: While traditionally a slower-moving market,
              our advanced algorithms are adept at identifying lucrative
              opportunities in real estate contracts, maximizing investment
              potential.
              <br />
              Commodities: From precious metals like gold and silver to
              essential commodities like oil and agricultural products, our
              algorithms are fine-tuned to the unique rhythms of each market,
              ensuring timely and profitable trades.
              <br />
              ETFs (Exchange Traded Funds): With a keen eye on market indices,
              commodities, and other asset classes, our algorithms excel in the
              ETF space, exploiting price differentials and market trends for
              optimal gains.
              <br />
              Join us as we continue to explore and expand our presence in these
              and other emerging markets. With Quantome, you're always at the
              forefront of the financial world.
            </p> */}
            <p>
              At Quantome, we pride ourselves on our expertise across a diverse
              range of markets. Leveraging the power of algorithmic trading, we
              have established a strong presence in the following key sectors:
              <br />
              <br />
              <strong>
                &nbsp; &nbsp; 1. Stocks
                <br />
                &nbsp; &nbsp; 2. Foreign Exchange (Forex)
                <br />
                &nbsp; &nbsp; 3. Cryptocurrencies
                <br />
                &nbsp; &nbsp; 4. Real Estate Contracts
                <br />
                &nbsp; &nbsp; 5. Commodities
                <br />
                &nbsp; &nbsp; 6. ETFs (Exchange Traded Funds)
              </strong>
              <br />
              <br />
              Join us as we continue to explore and expand our presence in these
              and other emerging markets. With Quantome, you're always at the
              forefront of the financial world.
            </p>
          </div>
          <div className="services-explore-bottom-right">
            <div className="services-explore-bottom-right-inner crypto">
              <p>Cryptocurrency</p>
              <img src={crypto} alt="types" />
            </div>
            <div className="services-explore-bottom-right-inner forex m-lr-768">
              <p>Forex</p>
              <img src={forex} alt="types" />
            </div>
            <div className="services-explore-bottom-right-inner amazon">
              <p>Stocks</p>
              <img src={amazon} alt="types" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ServicesExplore;
